import { render, staticRenderFns } from "./UsersStatisticsTable.vue?vue&type=template&id=7c5feda6&scoped=true"
import script from "./UsersStatisticsTable.vue?vue&type=script&lang=js"
export * from "./UsersStatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./UsersStatisticsTable.vue?vue&type=style&index=0&id=7c5feda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5feda6",
  null
  
)

export default component.exports